<div class="row no-gutters">

    <div class="col-md-10 col-lg-11">
        <div class="smp-title-thin-border" [ngClass]="{ 'has-error': validationMissingRoles }">{{ user.trans.roles | translate }} *</div>
        <div *ngIf="validationMissingRoles" class="error-msg iq-color-warn-light">{{ getRolesError()| translate }}</div>
    </div>

</div>

<div class="row no-gutters mt-4">

    <div class="col-12">
        <dynamic-checkboxes [idPrefix]="(idPrefix + 'client_user.roles.')"
                            [current]="selectedRoles"
                            [options]="roles?.items"
                            [disabledOptions]="[]"
                            [patchPath]="'not_used'"
                            (updated)="updateRoles($event)">
        </dynamic-checkboxes>
    </div>

</div>
